/**
 * AttemptsList Component
 * Displays previous test attempts
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Attempt } from '../../types/dashboard';

interface AttemptsListProps {
  attempts: Attempt[];
}

export const AttemptsList: React.FC<AttemptsListProps> = ({ attempts }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-lg p-5">
      <h2 className="text-lg font-bold text-gray-800 mb-4">Parties précédentes</h2>
      
      {attempts.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="space-y-3">
          {attempts.map((attempt) => (
            <AttemptCard 
              key={attempt.attempt_id || attempt.id} 
              attempt={attempt}
              onViewDetails={() => navigate(`/results/${attempt.attempt_id || attempt.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// Empty state component
const EmptyState: React.FC = () => (
  <p className="text-gray-500 text-base text-center py-6">
    Aucune partie pour le moment
  </p>
);

// Individual attempt card
interface AttemptCardProps {
  attempt: Attempt;
  onViewDetails: () => void;
}

const AttemptCard: React.FC<AttemptCardProps> = ({ attempt, onViewDetails }) => {
  const id = attempt.attempt_id || attempt.id;
  const score = attempt.score || attempt.total_score;
  const formattedDate = attempt.completed_at 
    ? new Date(attempt.completed_at).toLocaleDateString('fr-FR')
    : '-';

  return (
    <div className="border rounded-lg p-4 flex justify-between items-center hover:shadow-md transition bg-gray-50">
      <div>
        <p className="font-semibold text-base text-gray-800">Partie {id}</p>
        <p className="text-base text-gray-600">
          {formattedDate} - Version {attempt.version}
        </p>
      </div>
      
      <div className="flex items-center gap-4">
        <div className="text-right">
          <p className="text-2xl font-bold text-primary">{attempt.percentage}%</p>
          <p className="text-base text-gray-600">
            {score}/{attempt.max_score} points
          </p>
        </div>
        
        <button
          onClick={onViewDetails}
          className="bg-secondary bg-opacity-10 text-secondary text-base font-semibold px-4 py-2 rounded-lg hover:bg-opacity-20 transition"
        >
          Details
        </button>
      </div>
    </div>
  );
};

export default AttemptsList;
